// "Partner portal events" tracking sheet → Sign up screen, Tier 1. Labels are the
// sheet's event names verbatim.
export const onboarding_events = {
  onboarding_sign_in_tab_click: {
    category: 'Sign up screen',
    action: 'Sign In tab click',
    label: 'onboarding-sign-in-tab-click',
  },
  onboarding_sign_up_tab_click: {
    category: 'Sign up screen',
    action: 'Sign Up tab click',
    label: 'onboarding-sign-up-tab-click',
  },
  onboarding_sign_in_pc_click: {
    category: 'Sign up screen',
    action: 'Partner code field click',
    label: 'onboarding-sign-in-pc-click',
  },
  onboarding_sign_in_submit_click: {
    category: 'Sign up screen',
    action: 'Sign in click',
    label: 'onboarding-sign-in-submit-click',
  },
  onboarding_sign_up_submit_click: {
    category: 'Sign up screen',
    action: 'Sign up submit click',
    label: 'onboarding-sign-up-submit-click',
  },
};
